import type { EyeStyleOptions } from './AppearanceDefinitions';

/**
 * Player eye default (plan 12 §7, DJ 2026-10-07): players draw two matching
 * eyes; facing shows through placement (eyes and mouth toward the facing side,
 * forward pupils, the nose and the held weapon), not one eye drawn bigger.
 * The old near-big look stays an opt-in: `eyeStyle: { style: 'profile' }`.
 *
 * Applied at the player render boundary only (PlayerRenderer and
 * CharacterPortrait, through withPlayerLook in playerLook.ts), so NPC textures are untouched. The character creator
 * can later store an `eyeStyle`; an appearance that already has one keeps it.
 */
export const PLAYER_DEFAULT_EYE_STYLE: Readonly<EyeStyleOptions> = Object.freeze({ style: 'matched' });

export function withPlayerEyes<T extends { eyeStyle?: EyeStyleOptions }>(appearance: T): T {
  return appearance.eyeStyle ? appearance : { ...appearance, eyeStyle: PLAYER_DEFAULT_EYE_STYLE };
}
